<template>
  <div>
    <van-form @submit="onSubmit" ref="myForm" :disabled="formDisabled">
      <div class="information-box">
        <div class="information-title">{{ $t("form.title.basic") }}</div>
        <!-- 上传照片 -->
        <div class="upload-photos">
          <!-- 照片 -->
          <div class="upload-photos-title">{{ $t("upload_photo.title") }}</div>
          <div class="upload-photo-box">
            <van-uploader
              v-model="fileList.avatar"
              :max-count="1"
              class=""
              :after-read="uploadAvatar"
              @delete="deleteAvatar"
              :disabled="formDisabled"
              :before-delete="() => !formDisabled"
              upload-icon=""
            />
            <div class="upload-photos-tips">
              <div class="upload-photos-tips-top request">
                {{ $t("upload_photo.avatar_str") }}
              </div>
              <div class="upload-photos-tips-content">
                {{ $t("upload_photo.avatar_tip1") }}<br />
                {{ $t("upload_photo.avatar_tip2") }}<br />
                {{ $t("upload_photo.avatar_tip3") }}<br />
                {{ $t("upload_photo.avatar_tip4") }}
              </div>
            </div>
          </div>
          <!-- 国际嘉宾——证件照 -->
          <div class="upload-photo-box" v-if="peopleType === 'GT_I'">
            <van-uploader
              v-model="fileList.photo"
              :max-count="1"
              class=""
              :after-read="uploadPhoto"
              @delete="deletePhoto"
              :disabled="formDisabled"
              :before-delete="() => !formDisabled"
              upload-icon=""
            />
            <div class="upload-photos-tips">
              <div class="upload-photos-tips-top">
                {{ $t("upload_photo.photo_str") }}
              </div>
              <div class="upload-photos-tips-content">
                {{ $t("upload_photo.photo_tip1") }}<br />
                {{ $t("upload_photo.avatar_tip2") }}<br />
                {{ $t("upload_photo.avatar_tip3") }}<br />
                {{ $t("upload_photo.avatar_tip4") }}
              </div>
            </div>
          </div>
          <!-- 国际嘉宾——护照首页 -->
          <div class="upload-photo-box small" v-if="peopleType === 'GT_I'">
            <van-uploader
              v-model="fileList.passport"
              :max-count="1"
              class=""
              :after-read="uploadPassport"
              @delete="deletePassport"
              :disabled="formDisabled"
              :before-delete="() => !formDisabled"
              upload-icon=""
            />
            <div class="upload-photos-tips">
              <div class="upload-photos-tips-top request">
                {{ $t("upload_photo.passport_str") }}
              </div>
              <div class="upload-photos-tips-content">
                {{ $t("upload_photo.passport_tip1") }}<br />
                {{ $t("upload_photo.passport_tip2") }}<br />
                {{ $t("upload_photo.passport_tip3") }}
              </div>
            </div>
          </div>
        </div>
        <!-- 基础信息列表 -->
        <template v-for="(item, index) in basicInfo">
          <div
            class="item"
            :key="index"
            v-if="
              item.key !== 'nation' ||
              form.nationality === '' ||
              form.nationality === 'nationality_1'
            "
            v-show="item.show ? item.show() : true"
            :class="!item.label ? 'no-label' : ''"
          >
            <van-field
              v-model="form[item.key]"
              :label="$t(item.label)"
              :right-icon="item.arrowIcon === '' ? '' : 'arrow-down'"
              :class="{
                'input-radio':
                  item.label === 'form.label.gender' ||
                  item.label === 'form.label.documentVal' ||
                  item.label === 'form.label.needInvitationLetter',
              }"
              :placeholder="$t(item.placeholder)"
              :readonly="item.arrowIcon === '' ? false : true"
              :clickable="item.arrowIcon === '' ? false : true"
              :disabled="item.disabled || formDisabled"
              @click="
                item.disabled || formDisabled ? '' : openPop(item.key, index)
              "
              v-if="
                item.key !== 'idValidityType' &&
                item.key !== 'idValidity' &&
                item.key !== 'idType' &&
                item.key !== 'idTypeOther'
              "
            >
              <template #input v-if="item.type === 'sel'">
                <template>
                  <input
                    type="text"
                    readonly="readonly"
                    :disabled="item.disabled || formDisabled"
                    :placeholder="$t(item.placeholder)"
                    class="van-field__control"
                    :value="dict[item.key][form[item.key]]"
                  />
                </template>
              </template>

              <template #input v-else-if="item.label === 'form.label.gender'">
                <div
                  class="radio"
                  :class="{
                    'radio-checked': dict.gender[form.gender] === item1,
                    disabled: item.disabled || formDisabled,
                  }"
                  v-for="item1 in gender"
                  :key="item1"
                  @click.stop="
                    item.disabled || formDisabled
                      ? ''
                      : (form.gender = {
                          男: '男',
                          女: '女',
                          保密: '保密',
                          male: '男',
                          female: '女',
                          secrecy: '保密',
                        }[item1])
                  "
                >
                  {{ item1 }}
                </div>
              </template>

              <template
                #input
                v-else-if="item.label === 'form.label.needInvitationLetter'"
              >
                <div
                  class="radio"
                  :class="{
                    'radio-checked': form.needInvitationLetter === '1',
                    disabled: item.disabled || formDisabled,
                  }"
                  @click.stop="
                    item.disabled || formDisabled
                      ? ''
                      : (form.needInvitationLetter = '1')
                  "
                >
                  {{ $t("yes_str") }}
                </div>
                <div
                  class="radio"
                  :class="{
                    'radio-checked': form.needInvitationLetter === '0',
                    disabled: item.disabled || formDisabled,
                  }"
                  @click.stop="
                    item.disabled || formDisabled
                      ? ''
                      : (form.needInvitationLetter = '0')
                  "
                >
                  {{ $t("no_str") }}
                </div>
              </template>

              <template
                #input
                v-else-if="item.label === 'form.label.documentVal'"
              >
                <div class="row-input-box left">
                  <input
                    type="text"
                    readonly="readonly"
                    :placeholder="$t(item.placeholder)"
                    class="van-field__control left"
                    :value="dict[item.key][form[item.key]]"
                    @click="openPop(item.key, index)"
                  />
                </div>
              </template>

              <template #input v-else-if="item.type === 'multiSel'">
                <input
                  type="text"
                  readonly="readonly"
                  :disabled="item.disabled || formDisabled"
                  :placeholder="$t(item.placeholder)"
                  class="van-field__control"
                  :value="fieldName[item.key]"
                />
              </template>

              <template #label v-if="item.label === 'form.label.photo'"
                >{{ $t("form.label.photo")
                }}<img class="asterisk" :src="star" alt="" />
                <img
                  src="@/assets/img/infoIcon01.svg"
                  alt=""
                  @click="photo = true"
                />
              </template>
              <template
                #label
                v-else-if="item.label === 'form.label.resumePhoto'"
                >{{ $t("form.label.resumePhoto") }}
                <img
                  src="@/assets/img/infoIcon01.svg"
                  alt=""
                  @click="resumePhoto = true"
                />
              </template>
              <template #label v-else-if="item.rule">
                <!-- 国际嘉宾的名改为姓名 -->
                <!-- {{peopleType === 'GT_I' && (item.label === 'form.label.nameCh' || item.label === 'form.label.nameEn') ? $t(item.label + '_I') : $t(item.label)}} -->
                {{ $t(item.label) }}
                <!-- 国际嘉宾的单位及职务中非必填 -->
                <img class="asterisk" :src="star" alt="" v-if="item.rule" />
              </template>
            </van-field>

            <div class="vant-input-row" v-else-if="item.key === 'idType'">
              <van-field
                v-model="form[item.key]"
                :label="$t(item.label)"
                class="left"
                right-icon="arrow-down"
                :clickable="true"
                @click="
                  item.disabled || formDisabled ? '' : openPop('idType', index)
                "
                :disabled="item.disabled || formDisabled"
              >
                <template #input>
                  <input
                    type="text"
                    readonly="readonly"
                    :disabled="item.disabled || formDisabled"
                    :placeholder="$t(item.placeholder)"
                    class="van-field__control"
                    :value="dict[item.key][form[item.key]]"
                  />
                </template>
                <template #label>
                  {{ $t(item.label) }}
                  <img class="asterisk" :src="star" alt="" v-if="item.rule" />
                </template>
              </van-field>
              <van-field
                v-model="form.idTypeOther"
                class="right"
                v-if="
                  dict.idType[form.idType] === '其他' ||
                  dict.idType[form.idType] === 'Other'
                "
                :disabled="formDisabled"
                :placeholder="$t('form.label.enter')"
              >
              </van-field>
            </div>
            <div
              class="vant-input-row idValidityType"
              v-else-if="item.key === 'idValidityType'"
            >
              <van-field
                v-model="form[item.key]"
                :label="$t(item.label)"
                class="left"
                right-icon="arrow-down"
                :clickable="true"
                @click="
                  item.disabled || formDisabled
                    ? ''
                    : openPop('idValidityType', index)
                "
                :disabled="item.disabled || formDisabled"
              >
                <template #input>
                  <input
                    type="text"
                    readonly="readonly"
                    :disabled="item.disabled || formDisabled"
                    :placeholder="$t(item.placeholder)"
                    class="van-field__control"
                    :value="dict[item.key][form[item.key]]"
                  />
                </template>
              </van-field>
              <van-field
                v-model="form.idValidity"
                class="right"
                right-icon="arrow-down"
                :clickable="true"
                readonly="readonly"
                @click="
                  item.disabled || formDisabled
                    ? ''
                    : openPop('idValidity', index + 1)
                "
                :placeholder="$t(item.placeholder)"
                v-if="form.idValidityType == 1"
                :disabled="formDisabled"
              >
              </van-field>
            </div>
          </div>
        </template>
      </div>
      <div class="line"></div>
      <!-- 职务信息 -->
      <div class="information-box">
        <div class="information-title">{{ $t("form.title.post") }}</div>
        <div
          class="item item2"
          v-for="(item, index) in peopleType === 'GT_I' ? postInfoEn : postInfo"
          :key="index"
        >
          <van-field
            v-model="form[item.key]"
            :label="$t(item.label)"
            :placeholder="$t(item.placeholder)"
            :readonly="item.arrowIcon === '' ? false : true"
            :clickable="item.arrowIcon === '' ? false : true"
            :disabled="item.disabled || formDisabled"
            @click="
              item.disabled || formDisabled ? '' : openPop(item.key, index)
            "
            rows="5"
            autosize
            type="textarea"
            :maxlength="item.maxlength"
            show-word-limit
          >
            <template #input v-if="item.type === 'multiSel'">
              <input
                type="text"
                readonly="readonly"
                :disabled="item.disabled || formDisabled"
                :placeholder="$t(item.placeholder)"
                class="van-field__control"
                :value="fieldName[item.key]"
              />
            </template>
            <template #label v-if="item.rule"
              >{{ $t(item.label) }}<img class="asterisk" :src="star" alt=""
            /></template>
          </van-field>
        </div>
      </div>
      <div class="line"></div>
      <!-- 简历 -->
      <div class="information-box">
        <div class="information-title">{{ $t("form.title.resume") }}</div>
        <div class="item item2">
          <van-field
            :label="$t('form.label.resumeCh')"
            v-model="form.resume"
            rows="5"
            autosize
            type="textarea"
            maxlength="100"
            show-word-limit
            :placeholder="$t('form.label.resumeChPlaceholder')"
          ></van-field>
        </div>
        <div class="item item2">
          <van-field
            :label="$t('form.label.resumeEn')"
            v-model="form.enResume"
            rows="5"
            autosize
            type="textarea"
            maxlength="1000"
            show-word-limit
            :placeholder="$t('form.label.resumeEnPlaceholder')"
            :rules="[{ required: true, message: $t('input.emailTip') }]"
          ></van-field>
        </div>
      </div>
      <!-- <div class="line"></div> -->
      <!-- 其他信息 -->
      <!-- <div class="information-box">
        <div class="information-title">{{$t('form.title.other')}}</div>
        <div class="item">
          <van-field readonly clickable
            right-icon="arrow"
            @click="formDisabled ? '' : showVaccinesPicker = true">
            <template #label>{{$t('form.label.vaccinated')}}<img class="asterisk" :src="star" alt=""/></template>
            <template #input>
              <input type="text" readonly="readonly" :disabled="formDisabled" :placeholder="$t3('请选择', 'Please select ...')" class="van-field__control" :value="dict.vaccines[form.vaccinationWhether]" />
            </template>
          </van-field>
        </div>
        <div class="item item2" v-if="(['一针', '两针', '加强针', '是'].indexOf(form.vaccinationWhether) >= 0)">
          <van-field name="uploader" :label="$t('form.label.vaccinePhoto')" class="img-upload">
            <template #input>
              <van-uploader v-model="fileList.vaccinationImage" :after-read="afterRead" @delete="deleteVaccination" :max-count="3" :upload-text="$t3('上传图片', 'Upload')" :disabled="formDisabled" :before-delete="() => !formDisabled"/>
            </template>
            <template #label>{{$t('form.label.vaccinePhoto')}}<img class="asterisk" :src="star" alt=""/></template>
          </van-field>
        </div>
        <div class="item item2" v-else-if="form.vaccinationWhether === '未接种' || form.vaccinationWhether === '否'">
          <van-field :label="$t('form.label.explain')"
            v-model="form.reason" rows="5" 
            autosize type="textarea" 
            maxlength="200" show-word-limit
            :placeholder="$t('form.label.enter')">
            <template #label>{{$t('form.label.explain')}}<img class="asterisk" :src="star" alt=""/></template>
          </van-field>
        </div>
      </div> -->

      <!-- 原联系方式 -->
      <div class="line"></div>
      <div class="information-box">
        <div class="information-title">{{ $t("form.title.person") }}</div>
        <div class="item">
          <van-field
            v-model="form.phoneNumber"
            :label="$t('form.label.phone')"
            :placeholder="$t('form.label.enter')"
            :maxlength="20"
          >
            <template #label
              >{{ $t3("手机号码（作为登录账号）", "Cell Number(for log-in)") }}
              <img class="asterisk" :src="star" alt="" />
            </template>
          </van-field>
        </div>
        <div class="item mailbox">
          <!-- :disabled="email"  -->
          <van-field
            v-model="form.email"
            :placeholder="$t('form.label.enter')"
            :maxlength="100"
          >
            <template #label>
              {{ $t3("邮箱（作为登录账号）", "E-mail(for log-in)")
              }}<img class="asterisk" :src="star" alt="" />
            </template>
          </van-field>
        </div>
        <!-- <div class="item">
          <van-field 
            v-model="form.areaId" 
            :label="$t('form.label.region')" 
            right-icon="arrow" 
            :placeholder="$t('form.label.choice')"
            readonly clickable
            @click="formDisabled ? '' : showPicker = true">
              <template #input>
                <input type="text" readonly="readonly" :disabled="formDisabled" :placeholder="$t3('请选择', 'Please select ...')" class="van-field__control" :value="areaDict[form.areaId]" />
              </template>
            </van-field>
        </div> -->
        <div class="item">
          <van-field
            v-model="form.address"
            :label="$t('form.label.address')"
            :placeholder="$t('form.label.enter')"
            :maxlength="100"
          />
        </div>
      </div>
      <div class="line"></div>
      <div class="information-box">
        <div class="information-title">{{ $t("form.title.work") }}</div>
        <div class="item" v-for="(item, index) in work" :key="index">
          <van-field
            v-model="form[item.key]"
            :label="$t(item.label)"
            :placeholder="$t(item.placeholder)"
            :maxlength="item.maxlength"
          />
        </div>
      </div>
      <div class="line"></div>
      <div class="information-box">
        <div class="information-title">{{ $t("form.title.urgent") }}</div>
        <div class="item" v-for="(item, index) in urgent" :key="index">
          <van-field
            v-model="form[item.key]"
            :label="$t(item.label)"
            :placeholder="$t(item.placeholder)"
            :maxlength="item.maxlength"
          />
        </div>
      </div>
    </van-form>
    <van-dialog
      v-model="photo"
      :title="$t('photoDia.title')"
      theme="round-button"
      :confirm-button-text="$t('gotIt')"
      class="notice-dialog"
    >
      <div class="notice-dialog-body">
        <div>{{ $t("photoDia.article1") }}</div>
        <div>{{ $t("photoDia.article2") }}</div>
        <div>{{ $t("photoDia.article3") }}</div>
        <div>{{ $t("photoDia.article4") }}</div>
      </div>
    </van-dialog>
    <van-dialog
      v-model="resumePhoto"
      :title="$t('resumePhotoDia.title')"
      theme="round-button"
      :confirm-button-text="$t('gotIt')"
      class="notice-dialog"
    >
      <div class="notice-dialog-body">
        <div>{{ $t("resumePhotoDia.article1") }}</div>
        <div>{{ $t("resumePhotoDia.article2") }}</div>
        <div>{{ $t("resumePhotoDia.article3") }}</div>
        <div>{{ $t("resumePhotoDia.article4") }}</div>
      </div>
    </van-dialog>

    <!-- 选择框 -->
    <van-popup v-model="showPicker" position="bottom">
      <van-picker
        show-toolbar
        :default-index="form[nowKey]"
        :columns="columns"
        @confirm="onConfirm"
        @cancel="showPicker = false"
      >
        <template #option="item">
          {{ dict[nowKey][item] }}
        </template>
      </van-picker>
    </van-popup>
    <!-- 多选框 -->
    <van-popup class="multi-picker" v-model="showMultiPicker" position="bottom">
      <van-picker
        show-toolbar
        @confirm="onConfirm"
        @cancel="showMultiPicker = false"
      >
      </van-picker>
      <van-checkbox-group v-model="fieldList[nowKey]">
        <van-cell-group>
          <van-cell
            v-for="(value, key, index) in dict[nowKey]"
            clickable
            :key="key"
            :title="value"
            @click="toggleMultiSel(index)"
          >
            <template #right-icon>
              <van-checkbox :name="key" ref="checkboxes" />
            </template>
          </van-cell>
        </van-cell-group>
      </van-checkbox-group>
    </van-popup>
    <!-- 日期选择 -->
    <van-popup v-model="showTimePicker" position="bottom">
      <van-datetime-picker
        v-model="currentDate"
        type="date"
        :title="$t3('选择年月日', 'Select date')"
        :min-date="minDate"
        :max-date="maxDate"
        @confirm="onTimeConfirm"
        @cancel="showTimePicker = false"
      />
    </van-popup>
    <!-- <van-calendar v-model="showTimePicker" :default-date="form[nowKey] ? new Date(form[nowKey].replace(/-/g, '/')) : new Date()" @confirm="onTimeConfirm" :min-date="new Date('1900/01/01')" :max-date="new Date('2099/01/01')" color="#026DE0"/> -->
    <!-- 疫苗选择 -->
    <van-popup v-model="showVaccinesPicker" position="bottom">
      <van-picker
        show-toolbar
        :columns="vaccines"
        @confirm="onVaccines"
        @cancel="showVaccinesPicker = false"
      />
      <template #option="item">
        {{ dict.vaccines[item] }}
      </template>
    </van-popup>
  </div>
</template>

<script>
import { objectMergLeft, fixedNumber } from "@/utils";
import { getDictSelArr } from "@/api/dict";
import { getStatusObjTwo } from "@/utils/common-config";
import { toMedia } from "@/utils/request";
import { addFile } from "@/api/file";
import { mapGetters } from "vuex";
import { getAreaTree } from "@/api/area";

const tmpForm = {
  id: undefined,
  surname: undefined,
  name: undefined,
  enSurname: undefined,
  enName: undefined,
  avatar: undefined,
  photo: undefined,
  passport: undefined,
  birthday: undefined,
  gender: undefined,
  nationality: undefined,
  nation: undefined,
  country: undefined,
  dietTaboo: undefined,
  idType: undefined,
  idTypeOther: undefined,
  idNumber: undefined,
  idValidityType: undefined,
  idValidity: undefined,
  company: undefined,
  enCompany: undefined,
  researchField: undefined,
  needInvitationLetter: undefined,
  job: undefined,
  enJob: undefined,
  resume: undefined,
  enResume: undefined,
  // vaccinationWhether: undefined,
  // vaccinationImage: undefined,
  // reason: undefined,
  phoneNumber: undefined,
  email: undefined,
  // areaId: undefined,
  address: undefined,
  contact: undefined,
  contactPhone: undefined,
  contactEmail: undefined,
  emergencyContact: undefined,
  emergencyContactPhone: undefined,
  emergencyContactEmail: undefined,
  emergencyContactRemark: undefined,
};

export default {
  name: "personInfo",
  props: ["formDisabled"],
  data() {
    return {
      star: require("@/assets/img/asterisk.svg"),
      form: {},
      person: {
        phone: "",
        mail: "",
        area: "",
        address: "",
      },
      zhResume: "请按格式填写：所属单位；当前职务；任职时间；",
      enResume:
        "Zhang Wei is now a spokesman for the China political    office.",
      basicInfo: [
        {
          key: "surname",
          rule: false,
          label: "form.label.surnameCh",
          arrowIcon: "",
          placeholder: "form.label.enter",
          disabled: false
        },
        {
          key: "name",
          rule: false,
          label: "form.label.nameCh",
          arrowIcon: "",
          placeholder: "form.label.enter",
          disabled: false,
        },
        {
          key: "enSurname",
          rule: false,
          label: "form.label.surnameEn",
          arrowIcon: "",
          placeholder: "form.label.enter",
          disabled: false,
          show: () => this.peopleType === 'GT_I'
        },
        {
          key: "enName",
          rule: false,
          label: "form.label.nameEn",
          arrowIcon: "",
          placeholder: "form.label.enter",
          disabled: false,
          show: () => this.peopleType === 'GT_I'
        },
        // {
        //   key: 'avatar',
        //   rule: true,
        //   label: 'form.label.photo',
        //   icon: require('@/assets/img/infoIcon01.svg'),
        //   arrowIcon: '',
        // },
        // {
        //   key: 'photo',
        //   rule: false,
        //   label: 'form.label.resumePhoto',
        //   icon: require('@/assets/img/infoIcon01.svg'),
        //   arrowIcon: '',
        // },
        {
          key: "birthday",
          label: "form.label.birth",
          icon: "",
          arrowIcon: "arrow",
          placeholder: "form.label.choice",
        },
        {
          key: "gender",
          rule: true,
          label: "form.label.gender",
          icon: "",
          arrowIcon: "",
          placeholder: "",
          type: "radio",
          disabled: false,
        },
        {
          key: "nationality",
          rule: true,
          label: "form.label.nationality",
          icon: "",
          arrowIcon: "arrow",
          placeholder: "form.label.choice",
          type: "sel",
        },
        {
          key: "nation",
          rule: false,
          label: "form.label.nation",
          icon: require("@/assets/img/infoIcon01.svg"),
          arrowIcon: "arrow",
          placeholder: "form.label.choice",
          type: "sel",
        },
        // {
        //   key: "country",
        //   rule: true,
        //   label: "form.label.country",
        //   icon: require("@/assets/img/infoIcon01.svg"),
        //   arrowIcon: "arrow",
        //   placeholder: "form.label.choice",
        //   type: "sel",
        // },
        {
          label: "form.label.documentType",
          icon: "",
          key: "idType",
          rule: true,
          arrowIcon: "arrow",
          type: "sel",
          placeholder: "form.label.choice",
        },
        // {
        //   show: () =>
        //     this.dict.idType[this.form.idType] === '其他' ||
        //     this.dict.idType[this.form.idType] === 'Other',
        //   label: '',
        //   icon: '',
        //   key: 'idTypeOther',
        //   arrowIcon: '',
        //   placeholder: 'form.label.enter',
        // },
        {
          key: "idNumber",
          rule: true,
          label: "form.label.documentNum",
          icon: "",
          arrowIcon: "",
          placeholder: "form.label.enter",
        },
        {
          label: "form.label.documentVal",
          icon: "",
          key: "idValidityType",
          arrowIcon: "",
          type: "",
          placeholder: "form.label.choice",
          disabled: false,
        },
        // {
        //   show: () => this.form.idValidityType == 1,
        //   label: '',
        //   icon: '',
        //   key: 'idValidity',
        //   arrowIcon: 'arrow',
        //   placeholder: 'form.label.choice',
        // },
        {
          label: "form.label.researchField",
          icon: "",
          key: "researchField",
          arrowIcon: "arrow",
          type: "multiSel",
          placeholder: "form.label.choice",
        },
        {
          key: "needInvitationLetter",
          rule: true,
          label: "form.label.needInvitationLetter",
          icon: "",
          arrowIcon: "",
          placeholder: "",
          type: "radio",
          disabled: false,
        },
        {
          key: "dietTaboo",
          label: "form.label.diet",
          icon: "",
          arrowIcon: "arrow",
          placeholder: "form.label.choice",
          type: "sel",
        },
      ],
      postInfo: [
        {
          label: "form.label.companyCh",
          arrowIcon: "",
          rule: true,
          key: "company",
          placeholder: "form.label.enter",
          maxlength: 100,
        },
        {
          label: "form.label.companyEn",
          arrowIcon: "",
          key: "enCompany",
          placeholder: "form.label.enter",
          maxlength: 200,
        },
        // {
        //   label: 'form.label.researchField',
        //   icon: '',
        //   key: 'researchField',
        //   arrowIcon: 'arrow',
        //   type: 'multiSel',
        //   placeholder: 'form.label.choice',
        // }
      ],
      postInfoEn: [
        {
          label: "form.label.companyCh",
          arrowIcon: "",
          key: "company",
          placeholder: "form.label.enter",
          maxLength: 200,
        },
        {
          label: "form.label.companyEn",
          arrowIcon: "",
          rule: true,
          key: "enCompany",
          placeholder: "form.label.enter",
          maxLength: 200,
        },
      ],
      work: [
        {
          label: "form.label.contact.work",
          key: "contact",
          placeholder: "form.label.enter",
          maxlength: 20,
        },
        {
          label: "form.label.phone",
          key: "contactPhone",
          placeholder: "form.label.enter",
          maxlength: 20,
        },
        {
          label: "mailbox",
          key: "contactEmail",
          placeholder: "form.label.enter",
          maxlength: 100,
        },
      ],
      urgent: [
        {
          label: "form.label.contact.urgent",
          key: "emergencyContact",
          placeholder: "form.label.enter",
          maxlength: 20,
        },
        {
          label: "form.label.phone",
          key: "emergencyContactPhone",
          placeholder: "form.label.enter",
          maxlength: 20,
        },
        {
          label: "mailbox",
          key: "emergencyContactEmail",
          placeholder: "form.label.enter",
          maxlength: 100,
        },
      ],
      rules: {
        avatar: [{ msg: ["请上传照片", "Please upload Photo."] }],
        gender: [{ msg: ["请选择性别", "Please select Gender."] }],
        nationality: [{ msg: ["请选择国家", "Please select Country."] }],
        idType: [{ msg: ["请选择证件类型", "Please select ID Type."] }],
        idNumber: [{ msg: ["证件号不能为空", "ID Number is required."] }],
        // idValidity: [{ msg: ['请选择证件有效期', 'Please select id validity'] }],
        // 国内嘉宾不需要选是否需要提供签证邀请函
        // needInvitationLetter: [{ msg: ['请选择是否需要提供签证邀请函', '请选择是否需要提供签证邀请函'] }],
        // company: [{ msg: ['单位及职务（中）不能为空', 'company is required.'] }],
        // enCompany: [{ msg: ['单位（英）不能为空', 'company is required.'] }],
        // vaccinationWhether: [{ msg: ['请选择是否接种疫苗', 'Please select Vaccinated'] }],
        phoneNumber: [
          { msg: ["手机号码不能为空", "phone is required."] },
          {
            regex: /^1[3-9][0-9]{9}$/,
            msg: ["手机号格式有误", "Error phone format"],
          },
        ],
        email: [
          { msg: ["邮箱不能为空", "E-mail is required."] },
          {
            regex: /^[^\s@]+@[a-zA-Z0-9_-]+(.[a-zA-Z0-9_-]+)+$/,
            msg: ["邮箱格式有误", "E-mail is not in the required format."],
          },
        ],
        contactPhone: [
          {
            regex: /^1[3-9][0-9]{9}$/,
            msg: ["工作人员手机号格式有误", "Error work phone format"],
            canNull: true,
          },
        ],
        contactEmail: [
          {
            regex: /^[^\s@]+@[a-zA-Z0-9_-]+(.[a-zA-Z0-9_-]+)+$/,
            msg: [
              "工作人员邮箱格式有误",
              "Work E-mail is not in the required format.",
            ],
            canNull: true,
          },
        ],
        emergencyContactPhone: [
          {
            regex: /^1[3-9][0-9]{9}$/,
            msg: ["紧急联系人手机号格式有误", "Error emergency phone format"],
            canNull: true,
          },
        ],
        emergencyContactEmail: [
          {
            regex: /^[^\s@]+@[a-zA-Z0-9_-]+(.[a-zA-Z0-9_-]+)+$/,
            msg: [
              "紧急联系人邮箱格式有误",
              "Emergency E-mail is not in the required format.",
            ],
            canNull: true,
          },
        ],
      },
      rules1: {
        avatar: [{ msg: ["请上传照片", "Please upload Photo."] }],
        gender: [{ msg: ["请选择性别", "Please select Gender."] }],
        passport: [{ msg: ["请上传护照首页", "Please upload your passport"] }],
        nationality: [{ msg: ["请选择国家", "Please select Country."] }],
        idType: [{ msg: ["请选择证件类型", "Please select ID Type."] }],
        idNumber: [{ msg: ["证件号不能为空", "ID Number is required."] }],
        // idValidity: [{ msg: ['请选择证件有效期', 'Please select id validity'] }],
        needInvitationLetter: [
          {
            msg: [
              "请选择是否需要提供签证邀请函",
              "Please choose whether you need a visa invitation letter",
            ],
          },
        ],
        // company: [{ msg: ['单位及职务（中）不能为空', 'company is required.'] }],
        // enCompany: [{ msg: ['单位（英）不能为空', 'company is required.'] }],
        // vaccinationWhether: [{ msg: ['请选择是否接种疫苗', 'Please select Vaccinated'] }],
        phoneNumber: [{ msg: ["手机号码不能为空", "phone is required."] }],
        email: [
          { msg: ["邮箱不能为空", "E-mail is required."] },
          {
            regex: /^[^\s@]+@[a-zA-Z0-9_-]+(.[a-zA-Z0-9_-]+)+$/,
            msg: ["邮箱格式有误", "E-mail is not in the required format."],
          },
        ],
        contactEmail: [
          {
            regex: /^[^\s@]+@[a-zA-Z0-9_-]+(.[a-zA-Z0-9_-]+)+$/,
            msg: [
              "工作人员邮箱格式有误",
              "Work E-mail is not in the required format.",
            ],
            canNull: true,
          },
        ],
        emergencyContactEmail: [
          {
            regex: /^[^\s@]+@[a-zA-Z0-9_-]+(.[a-zA-Z0-9_-]+)+$/,
            msg: [
              "紧急联系人邮箱格式有误",
              "Emergency E-mail is not in the required format.",
            ],
            canNull: true,
          },
        ],
      },
      areaTree: [],
      areaDict: {},
      photo: false,
      resumePhoto: false,
      uploader: [{ url: "https://img01.yzcdn.cn/vant/leaf.jpg" }],
      vaccinesVal: "是",
      showPicker: false,
      showMultiPicker: false,
      nowKey: "birthday",
      currentDate: new Date(),
      minDate: new Date(new Date().getTime() - 100 * 365 * 86400 * 1000),
      maxDate: new Date(new Date().getTime() + 100 * 365 * 86400 * 1000),
      showTimePicker: false,
      showVaccinesPicker: false,
      formIdx: 0,
      columns: [],
      gender: [
        this.$t3("男", "male"),
        this.$t3("女", "female"),
        // this.$t3("保密", "secrecy"),
      ],
      idValidityType: [1, 2],
      nationality: [],
      dietTaboo: [],
      nation: [],
      country: [],
      idType: [],
      dict: {
        gender: {
          男: this.$t3("男", "male"),
          女: this.$t3("女", "female"),
          保密: this.$t3("保密", "secrecy"),
          male: this.$t3("男", "male"),
          female: this.$t3("女", "female"),
          secrecy: this.$t3("保密", "secrecy"),
        },
        vaccines: {
          一针: this.$t3("一针", "Primary Dose I"),
          两针: this.$t3("两针", "Primary Dose II"),
          加强针: this.$t3("加强针", "Booster Dose"),
          否: this.$t3("未接种", "Unvaccinated"),
          未接种: this.$t3("未接种", "Unvaccinated"),
          "Primary Dose I": this.$t3("一针", "Primary Dose I"),
          "Primary Dose II": this.$t3("两针", "Primary Dose II"),
          "Booster Dose": this.$t3("加强针", "Booster Dose"),
          Unvaccinated: this.$t3("未接种", "Unvaccinated"),
        },
        idValidityType: [
          "",
          this.$t3("有效期", "Valid until"),
          this.$t3("长期", "Permanent"),
        ],
        nationality: {},
        dietTaboo: {},
        nation: {},
        country: {},
        idType: {},
      },
      fieldName: {
        researchField: "",
      },
      fieldList: {
        researchField: [],
      },
      vaccines: [
        this.$t3("一针", "Primary Dose I"),
        this.$t3("两针", "Primary Dose II"),
        this.$t3("加强针", "Booster Dose"),
        this.$t3("未接种", "Unvaccinated"),
      ],
      explain: "",
      fileList: {
        avatar: [],
        photo: [],
        passport: [],
        vaccinationImage: [],
      },
      uploadLoading: false,
      vaccinationImageList: [],
    };
  },
  computed: {
    ...mapGetters([
      "peopleType",
      "nameField",
      "enNameField",
      "surname",
      "enSurname",
    ]),
  },
  mounted() {
    this.getAreaTree();
    this.getDictSelArr();
    this.initDisable();
  },
  methods: {
    toMedia,
    initDisable() {
      const field0 = Object.assign({}, this.basicInfo[0]);
      const field1 = Object.assign({}, this.basicInfo[1]);
      const field2 = Object.assign({}, this.basicInfo[2]);
      const field3 = Object.assign({}, this.basicInfo[3]);
      if (this.peopleType === "GT_I") {
        field0.key = "name";
        field0.label = "form.label.nameCh_I";
        field1.key = "surname";
        field1.label = "form.label.surnameCh";
        field2.key = "enName";
        field2.label = "form.label.nameEn_I";
        field2.rule = true;
        field3.key = "enSurname";
        field3.label = "form.label.surnameEn";
        // 英文，姓名（英）反显了的话不能修改
        if (this.enNameField) {
          field2.disabled = true;
        }
        // 国际嘉宾不选民族
        this.basicInfo.splice(7, 1);
      } else {
        field0.key = "surname";
        field0.label = "form.label.surnameCh";
        field0.rule = true;
        field1.key = "name";
        field1.label = "form.label.nameCh";
        field1.rule = true;
        field2.key = "enSurname";
        field2.label = "form.label.surnameEn";
        field3.key = "enName";
        field3.label = "form.label.nameEn";
        // 中文，姓（中）名（中）反显了的话不能修改
        if (this.surname) {
          field0.disabled = true;
        }
        if (this.nameField) {
          field1.disabled = true;
        }
        // 国内嘉宾不选代表国家
        // this.basicInfo.splice(8, 1);
        // 国内嘉宾不选是否需要签证邀请函
        this.basicInfo.splice(12, 1);
        // 国内嘉宾不传简历照
        // this.basicInfo.splice(5, 1);
      }
      this.$set(this.basicInfo, 0, field0);
      this.$set(this.basicInfo, 1, field1);
      this.$set(this.basicInfo, 2, field2);
      this.$set(this.basicInfo, 3, field3);
    },
    initForm(form) {
      this.form = Object.assign({}, tmpForm);
      for (const key in this.fieldList) {
        this.fieldList[key] = [];
        this.fieldName[key] = "";
      }
      objectMergLeft(this.form, form);
      if (form.needInvitationLetter === 0) {
        this.form.needInvitationLetter = "0";
      } else if (form.needInvitationLetter === 1) {
        this.form.needInvitationLetter = "1";
      }
      if (this.form.avatar && this.form.avatar !== "") {
        this.fileList.avatar = [
          {
            url: toMedia(this.form.avatar),
            isImage: true,
          },
        ];
      }
      if (this.form.photo && this.form.photo !== "") {
        this.fileList.photo = [
          {
            url: toMedia(this.form.photo),
            isImage: true,
          },
        ];
      }
      if (this.form.passport && this.form.passport !== "") {
        this.fileList.passport = [
          {
            url: toMedia(this.form.passport),
            isImage: true,
          },
        ];
      }
      if (this.form.vaccinationImage && this.form.vaccinationImage !== "") {
        this.fileList.vaccinationImage = [];
        this.vaccinationImageList = [];
        this.form.vaccinationImage.split("|").forEach((x) => {
          this.fileList.vaccinationImage.push({
            url: toMedia(x),
            isImage: true,
          });
          this.vaccinationImageList.push(x);
        });
      }
      for (const key in this.fieldList) {
        if (this.form[key]) {
          this.fieldList[key] = this.form[key].split(",").filter((x) => x);
          if (this.dict[key] && Object.keys(this.dict[key]).length) {
            this.fieldName[key] = this.fieldList[key]
              .map((x) => this.dict[key][x])
              .join("、");
          }
        }
      }
      // 国内嘉宾默认身份证
      if (this.peopleType !== "GT_I") {
        this.form.idType = "MAINLAND_IDCARD";
        this.form.nationality = "nationality_1";
      }
    },
    validate() {
      return new Promise((resolve, reject) => {
        if (this.uploadLoading) {
          this.$notify(
            this.$t3(
              "有图片上传中，请稍后再试",
              "Please wait for the picture being uploaded."
            )
          );
          reject();
          return;
        }
        // 如果当前是国际嘉宾，则判断姓名中和英是否为空
        if (this.peopleType === "GT_I") {
          // if (!this.form.name) {
          //   this.$notify(this.$t3('姓名（中）不能为空', 'the name (CN) is required.'))
          //   reject();return
          // }
          if (!this.form.enName) {
            this.$notify(
              this.$t3(
                "姓名（英）不能为空",
                "Full Name (English) is required."
              )
            );
            reject();
            return;
          }
        } else {
          // 如果当前是国内嘉宾，则判断姓、名中和英是否为空
          if (!this.form.surname) {
            this.$notify(
              this.$t3("姓（中）不能为空", "Last Name (Chinese) is required.")
            );
            reject();
            return;
          }
          if (!this.form.name) {
            this.$notify(
              this.$t3("名（中）不能为空", "First Name (Chinese) is required.")
            );
            reject();
            return;
          }
          // if (!this.form.enSurname) {
          //   this.$notify(this.$t3('姓（英）不能为空', 'the surname (EN) is required.'))
          //   reject();return
          // }
          // if (!this.form.enName) {
          //   this.$notify(this.$t3('名（英）不能为空', 'the name (EN) is required.'))
          //   reject();return
          // }
        }
        // 如果证件类型是其他，则需要设置证件类型名称
        if (
          this.dict.idType[this.form.idType] === "其他" ||
          this.dict.idType[this.form.idType] === "Other"
        ) {
          if (!this.form.idTypeOther) {
            this.$notify(this.$t3("证件类型不能为空", "ID Type is required."));
            reject();
            return;
          }
        }
        // 如果证件类型是身份证，则需要判断位数是否是18位
        if (
          this.dict.idType[this.form.idType] === "身份证" ||
          this.dict.idType[this.form.idType] === "身份证号" ||
          this.dict.idType[this.form.idType] === "ID Card" ||
          this.dict.idType[this.form.idType] === "identity card"
        ) {
          if (this.form.idNumber && this.form.idNumber.length != 18) {
            this.$notify(
              this.$t3(
                "证件号码格式有误",
                "ID number is not in the required format."
              )
            );
            reject();
            return;
          }
        }
        // 如果证件有效期类型不是长期，则需要设置证件有效期
        // if (!this.form.idValidityType) {
        //   this.$notify(
        //     this.$t3('请选择证件有效期', 'Please select Date of Expiry.')
        //   );
        //   reject();
        //   return;
        // }
        // if (this.form.idValidityType == 1) {
        //   if (!this.form.idValidity) {
        //     this.$notify(
        //       this.$t3('请选择证件有效期', 'Please select Date of Expiry.')
        //     );
        //     reject();
        //     return;
        //   }
        // }
        let rules = this.rules;
        if (this.peopleType === "GT_I") {
          rules = this.rules1;
        }
        this.$validateI18n(this.form, rules).then(
          (res) => {
            if (res) {
              // 如果是国内嘉宾，则判断民族、单位及职务（中）是否填写
              if (this.peopleType !== "GT_I") {
                // if (!this.form.nation && this.form.nationality==='nationality_1') {
                //   this.$notify(this.$t3('请选择民族', 'Please select Ethnic Group.'))
                //   reject();return
                // }
                if (!this.form.company) {
                  this.$notify(
                    this.$t3(
                      "请填写单位及职务（中）",
                      "Title (Chinese) is required."
                    )
                  );
                  reject();
                  return;
                }
              } else {
                // 国际嘉宾要判断代表国家、单位及职务（英）
                // if (!this.form.country) {
                //   this.$notify(
                //     this.$t3("请选择代表国家", "Please select Representing.")
                //   );
                //   reject();
                //   return;
                // }
                if (!this.form.enCompany) {
                  this.$notify(
                    this.$t3(
                      "请填写单位及职务（英）",
                      "Title (English) is required."
                    )
                  );
                  reject();
                  return;
                }
              }
              // // 如果选择接种疫苗，则判断是否上传疫苗照片
              // if (['是', '一针', '两针', '加强针'].indexOf(this.form.vaccinationWhether) >= 0) {
              //   if (!this.form.vaccinationImage) {
              //     this.$notify(this.$t3('请上传接种疫苗相关截图', 'Please upload your vaccination certificate'))
              //     reject();return
              //   }
              // } else {
              //   // 如果选择未接种疫苗，则判断是否填写未接种说明
              //   if (!this.form.reason) {
              //     this.$notify(this.$t3('未接种说明不能为空', 'Reason(s) for non-vaccination is required.'))
              //     reject();return
              //   }
              // }
              resolve(true);
            } else {
              reject();
            }
          },
          () => {
            reject();
          }
        );
      });
    },
    getAreaTree() {
      getAreaTree({ maxDeep: 2 }).then((res) => {
        this.areaTree = res.data;
        this.areaDict = {};
        for (const areaP of this.areaTree) {
          const labelP = areaP.label;
          for (const area of areaP.children) {
            this.areaDict[area.id] = labelP + "/" + area.label;
          }
        }
      });
    },
    getDictSelArr() {
      getDictSelArr({
        conferenceId: this.$route.params.conferenceId,
        codes: "nation,nationality,diet_taboo,id_type,RESEARCH_FIELD",
      }).then((res) => {
        if (Object.hasOwnProperty.call(res.data, "id_type")) {
          this.idType = res.data.id_type.map((x) => x.code);
          this.dict.idType = getStatusObjTwo(
            this.$t3,
            res.data.id_type,
            "code",
            "name",
            "nameEn"
          );
        }
        if (Object.hasOwnProperty.call(res.data, "nationality")) {
          if (this.$i18n.locale === 'zh') {
            this.nationality = res.data.nationality
              .map((x) => x.code); 
          } else {
            this.nationality = res.data.nationality
              .sort((a, b) => {
                if (!a.nameEn) return 1;
                if (!b.nameEn) return -1;
                if (a.nameEn === 'China') return -1
                if (b.nameEn === 'China') return 1
                return a.nameEn < b.nameEn ? -1 : 1;
              })
              .map((x) => x.code);
          }
          this.nationality = res.data.nationality
            // .sort((a, b) => {
            //   if (!a.nameEn) return 1;
            //   if (!b.nameEn) return -1;
            //   return a.nameEn < b.nameEn ? -1 : 1;
            // })
            .map((x) => x.code);
          this.dict.nationality = getStatusObjTwo(
            this.$t3,
            res.data.nationality,
            "code",
            "name",
            "nameEn"
          );
          this.country = this.nationality;
          this.dict.country = this.dict.nationality;
        }
        if (Object.hasOwnProperty.call(res.data, "diet_taboo")) {
          this.dietTaboo = res.data.diet_taboo.map((x) => x.code);
          this.dict.dietTaboo = getStatusObjTwo(
            this.$t3,
            res.data.diet_taboo,
            "code",
            "name",
            "nameEn"
          );
        }
        if (Object.hasOwnProperty.call(res.data, "nation")) {
          this.nation = res.data.nation.map((x) => x.code);
          this.dict.nation = getStatusObjTwo(
            this.$t3,
            res.data.nation,
            "code",
            "name",
            "nameEn"
          );
        }
        if (Object.hasOwnProperty.call(res.data, "RESEARCH_FIELD")) {
          this.dict.researchField = getStatusObjTwo(
            this.$t3,
            res.data.RESEARCH_FIELD,
            "code",
            "name",
            "nameEn"
          );
        }
        for (const key in this.fieldList) {
          if (
            this.fieldList[key] &&
            this.fieldList[key].length &&
            this.dict[key] &&
            Object.keys(this.dict[key]).length
          ) {
            this.fieldName[key] = this.fieldList[key]
              .map((x) => this.dict[key][x])
              .join("、");
          }
        }
      });
    },
    // 上传头像
    uploadAvatar(params) {
      const file = params.file;
      this.uploadLoading = true;
      addFile({
        conferenceId: this.$route.params.conferenceId,
        file: file,
      }).then(
        (response) => {
          if (response.code && response.code === 200) {
            this.form.avatar = response.data;
          } else {
            this.fileList.avatar.pop();
          }
          this.uploadLoading = false;
        },
        () => {
          this.uploadLoading = false;
          this.fileList.avatar.pop();
        }
      );
    },
    uploadPhoto(params) {
      const file = params.file;
      this.uploadLoading = true;
      addFile({
        conferenceId: this.$route.params.conferenceId,
        file: file,
      }).then(
        (response) => {
          if (response.code && response.code === 200) {
            this.form.photo = response.data;
          } else {
            this.fileList.photo.pop();
          }
          this.uploadLoading = false;
        },
        () => {
          this.uploadLoading = false;
          this.fileList.photo.pop();
        }
      );
    },
    // 上传头像
    uploadPassport(params) {
      const file = params.file;
      this.uploadLoading = true;
      addFile({
        conferenceId: this.$route.params.conferenceId,
        file: file,
      }).then(
        (response) => {
          if (response.code && response.code === 200) {
            this.form.passport = response.data;
          } else {
            this.fileList.passport.pop();
          }
          this.uploadLoading = false;
        },
        () => {
          this.uploadLoading = false;
          this.fileList.passport.pop();
        }
      );
    },
    deleteAvatar() {
      this.form.avatar = "";
    },
    deletePhoto() {
      this.form.photo = "";
    },
    deletePassport() {
      this.form.passport = "";
    },
    // 上传核酸证明
    afterRead(params) {
      const file = params.file;
      this.uploadLoading = true;
      addFile({
        conferenceId: this.$route.params.conferenceId,
        file: file,
      }).then(
        (response) => {
          if (response.code && response.code === 200) {
            this.vaccinationImageList.push(response.data);
            this.form.vaccinationImage = this.vaccinationImageList.join("|");
          } else {
            this.fileList.vaccinationImage.pop();
          }
          this.uploadLoading = false;
        },
        () => {
          this.uploadLoading = false;
          this.fileList.vaccinationImage.pop();
        }
      );
    },
    deleteVaccination(params, indexParams) {
      const index = indexParams.index;
      this.vaccinationImageList.splice(index, 1);
      this.form.vaccinationImage = this.vaccinationImageList.join("|");
    },
    photoCareful(label) {
      if (label === "form.label.photo") {
        this.photo = true;
      }
      if (label === "form.label.resumePhoto") {
        this.resumePhoto = true;
      }
    },
    onSubmit(values) {
      console.log("submit", values);
    },
    goNext() {
      this.$router.push("contactInfo");
    },
    // 打开选择器
    openPop(key, idx) {
      console.log(key, idx);
      this.formIdx = idx;
      this.nowKey = key;
      if (key === "birthday" || key === "idValidity") {
        this.currentDate = this.form[this.nowKey]
          ? new Date(this.form[this.nowKey].replace(/-/g, "/"))
          : new Date();
        this.showTimePicker = true;
      }
      // this.showPicker = true
      // if (key === 'gender') {
      //   this.columns = this.gender;
      //   this.showPicker = true;
      // } else
      if (key === "nationality") {
        if (this.peopleType !== "GT_I") {
          for (const nationKey in this.nationality) {
            let nationItem = this.nationality[nationKey];
            if (nationItem === "nationality_1") {
              this.columns = [nationItem];
            }
          }
        } else {
          this.columns = this.nationality;
        }
        this.showPicker = true;
      } else if (key === "dietTaboo") {
        this.columns = this.dietTaboo;
        this.showPicker = true;
      } else if (key === "nation") {
        this.columns = this.nation;
        this.showPicker = true;
      } else if (key === "country") {
        this.columns = this.country;
        this.showPicker = true;
      } else if (key === "idType") {
        if (this.peopleType !== "GT_I") {
          for (const idTypeKey in this.idType) {
            let idTypeItem = this.idType[idTypeKey];
            if (idTypeItem === "MAINLAND_IDCARD") {
              this.columns = [idTypeItem];
            }
          }
        } else {
          this.columns = this.idType;
        }
        this.showPicker = true;
      } else if (key === "idValidityType") {
        this.columns = this.idValidityType;
        this.showPicker = true;
      } else if (key === "researchField") {
        this.fieldList[key] = this.form[key].split(",").filter((x) => x);
        if (this.dict[key] && Object.keys(this.dict[key]).length) {
          this.fieldName[key] = this.fieldList[key]
            .map((x) => this.dict[key][x])
            .join("、");
        }
        this.showMultiPicker = true;
      }
    },
    // 关闭选择器
    onConfirm(value) {
      if (this.nowKey === "gender") {
        this.form[this.nowKey] = {
          男: "男",
          女: "女",
          保密: "保密",
          male: "男",
          female: "女",
          secrecy: "保密",
        }[value];
      } else if (this.nowKey === "researchField") {
        this.form[this.nowKey] = this.fieldList[this.nowKey].join(",");
        this.fieldName[this.nowKey] = this.fieldList[this.nowKey]
          .map((x) => this.dict[this.nowKey][x])
          .join("、");
      } else if (this.nowKey === "areaId") {
        this.person.area = value;
        this.showPicker = false;
      } else {
        this.form[this.nowKey] = value;
      }
      this.showPicker = false;
      this.showMultiPicker = false;
    },
    onTimeConfirm(date) {
      this.form[this.nowKey] =
        date.getFullYear() +
        "-" +
        `${fixedNumber(date.getMonth() + 1)}-${fixedNumber(date.getDate())}`;
      this.showTimePicker = false;
    },
    onVaccines(value) {
      this.form.vaccinationWhether = {
        一针: "一针",
        两针: "两针",
        加强针: "加强针",
        否: "否",
        未接种: "否",
        "Primary Dose I": "一针",
        "Primary Dose II": "两针",
        "Booster Dose": "加强针",
        Unvaccinated: "否",
      }[value];
      this.showVaccinesPicker = false;
    },
    toggleMultiSel(index) {
      this.$refs.checkboxes[index].toggle();
    },
  },
};
</script>
